import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState, useEffect } from 'react';
import { SearchDialogAnalyticsContext, useAnalytics } from './analytics';
import { onExperimentLoaded } from './analytics/events';
import { ProductSearchInputSkeleton } from './product-search-input-skeleton';
export var DEFAULT_AB_TEST = {
  abTestId: 'default',
  controlId: 'default',
  experimentId: 'nav-v3'
};
var MISSING_PROVIDER_ERROR = new Error('Experimentation data has not been initialised, please ensure that there is an ABTestContext.Provider available');
export var ABTestContext = /*#__PURE__*/React.createContext({
  abTest: null
});
export var ABTestProvider = function ABTestProvider(_ref) {
  var searchClient = _ref.searchClient,
    isMultiProduct = _ref.isMultiProduct,
    children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    abTest = _useState2[0],
    setAbTest = _useState2[1];
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  useEffect(function () {
    var now = Date.now();
    searchClient.getAbTestData().then(function (abTestResponse) {
      var duration = Date.now() - now;
      var abTestWithDefault = abTestResponse || DEFAULT_AB_TEST;
      setAbTest(abTestWithDefault);
      fireAnalyticsEvent(onExperimentLoaded(abTestWithDefault, duration, !!isMultiProduct));
    }).catch(function (e) {
      setAbTest(DEFAULT_AB_TEST);
    });
  }, [searchClient, fireAnalyticsEvent, isMultiProduct]);
  if (!abTest) {
    return /*#__PURE__*/React.createElement(ProductSearchInputSkeleton, null);
  }
  return /*#__PURE__*/React.createElement(ABTestContext.Provider, {
    value: {
      abTest: abTest
    }
  }, /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
    analyticContext: {
      abTest: abTest
    },
    nonPrivacySafeAnalyticContext: {}
  }, children));
};
export var useABTest = function useABTest() {
  var _useContext = useContext(ABTestContext),
    abTest = _useContext.abTest;
  if (!abTest) {
    throw MISSING_PROVIDER_ERROR;
  }
  return abTest;
};